import * as React from 'react';

export default function CreditFilled({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#232D34"
          d="M17.355 8.397v-.522c0-2.351-3.547-4.125-8.25-4.125C4.4 3.75.854 5.524.854 7.875v3.75c0 1.958 2.46 3.515 6 3.98v.52c0 2.351 3.546 4.125 8.25 4.125 4.703 0 8.25-1.774 8.25-4.125v-3.75c0-1.94-2.384-3.499-6-3.978Zm-12 5.372c-1.837-.513-3-1.357-3-2.144v-1.32c.764.543 1.79.98 3 1.273v2.191Zm7.5-2.19c1.21-.294 2.234-.731 3-1.273v1.319c0 .787-1.164 1.631-3 2.144v-2.19Zm-1.5 6.69c-1.837-.513-3-1.357-3-2.144v-.39a18.074 18.074 0 0 0 1.818-.017c.387.138.781.256 1.181.352v2.2Zm0-4.183c-.745.11-1.497.165-2.25.164-.754 0-1.506-.054-2.25-.164v-2.23a17.22 17.22 0 0 0 2.25.144c.752.001 1.503-.047 2.25-.144v2.23Zm6 4.5a15.507 15.507 0 0 1-4.5 0V16.35a17.222 17.222 0 0 0 4.5.006v2.23Zm4.5-2.461c0 .787-1.164 1.631-3 2.144v-2.19c1.21-.294 2.235-.731 3-1.273v1.319Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.104 0h24v24h-24z" />
        </clipPath>
      </defs>
    </svg>
  );
}
